import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import HistoryTable from '../components/History/HistoryTable';
import AnalysisPreview from '../components/History/AnalysisPreview';
import { getAnalysis } from '../services/analyses';

const HistoryPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const hash = searchParams.get('hash');

  const [previewAnalysis, setPreviewAnalysis] = useState(null);

  useEffect(() => {
    if (hash) {
      loadAnalysisFromHash(hash);
    }
  }, [hash]);

  const loadAnalysisFromHash = async (analysisHash) => {
    try {
      const analysis = await getAnalysis(analysisHash);
      setPreviewAnalysis(analysis);
    } catch (error) {
      console.error('Error loading analysis:', error);
    }
  };

  // Conservar el resto de parámetros (página, búsqueda, filtro): antes se reescribía
  // la URL entera y al cerrar el plano la tabla volvía a la primera página.
  const handlePreview = (analysis) => {
    setPreviewAnalysis(analysis);
    const next = new URLSearchParams(searchParams);
    next.set('hash', analysis.hash);
    setSearchParams(next);
  };

  const handleClosePreview = () => {
    setPreviewAnalysis(null);
    const next = new URLSearchParams(searchParams);
    next.delete('hash');
    setSearchParams(next);
  };

  return (
    <div>
      {!previewAnalysis ? (
        <HistoryTable onPreview={handlePreview} />
      ) : (
        <AnalysisPreview analysis={previewAnalysis} onClose={handleClosePreview} />
      )}
    </div>
  );
};

export default HistoryPage;